import { defineComponent } from "vue";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import { mapWritableState } from "pinia";
import FloatingCard from "@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue";

export default defineComponent({
  components: {
    FloatingCard,
  },
  data() {
    return {
      hasError: false,
    };
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["testSymptoms"]),
    ...mapWritableState(useRegisterTestStore, ["canJumpNext"]),
  },
  methods: {
    setSymptoms(result: string) {
      this.testSymptoms = result;
      this.canJumpNext = true;
      this.hasError = false;
    },
    errorValidation() {
      this.hasError = true;
      return false;
    },
    isValidStep(): boolean {
      return this.testSymptoms != "";
    },
    setAnimationType( animationName: string ) {
      setTimeout( () => {
        const baseModal: any = this.$refs["base-modal"];
        switch (animationName) {
          case 'setNextDismissAnimation':
            baseModal.setNextDismissAnimation();
            break;
          case 'setNextShowAnimation':
            baseModal.setNextShowAnimation();
            break;
          case 'setPreviousDismissAnimation':
            baseModal.setPreviousDismissAnimation();
            break;
          case 'setPreviousShowAnimation':
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    }
  },
});
